import { ApiError, CancelButton, SubmitButton } from "components";
import { connect, useSelector } from "react-redux";
import { FormEvent, useEffect, useState } from "react";
import {SpecialOfferStatus } from "props/enum";
import { CreateSpecialOfferInput, SpecialOfferProps, stateStatusType } from "../state/actionType";
import { resetSpecialOffer, updateSpecialOffer } from "../state/action";

interface OwnProps {
 specailOfferData: SpecialOfferProps;
  onClose: () => void;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleChangeStatus: React.FC<Props> = ({
  specailOfferData,
  onResetSpecialOffer,
  onUpdateFeaturedAds,
  onClose,
}) => {
  const formatDate = (dateStr?: string) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const year = date.getFullYear();
  return `${year}/${month}/${day}`;
};
  const featuredAdsState = useSelector(
    (state: any) => state.featuredAds.genericFeaturedAdsState
  );
  const [formData, setFormData] = useState<CreateSpecialOfferInput>({
    title: specailOfferData?.title,
    status: specailOfferData?.status,
    description: specailOfferData?.description,
    start_date: formatDate(specailOfferData?.start_date),
    end_date: formatDate(specailOfferData?.end_date),
    number_of_days: specailOfferData?.number_of_days,
    membership_duration_id: specailOfferData?.membership_duration?.id,
  });
  const [apiError, setApiError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    const input: CreateSpecialOfferInput = {
      title: specailOfferData?.title,
      description: specailOfferData?.description,
      start_date: formatDate(specailOfferData?.start_date),
      end_date: formatDate(specailOfferData?.end_date),
      number_of_days: specailOfferData?.number_of_days,
      membership_duration_id: specailOfferData?.membership_duration?.id,
      status:
        specailOfferData.status === SpecialOfferStatus.Active
          ? SpecialOfferStatus.InActive
          : SpecialOfferStatus.Active,
    };
    const special_offer_id = specailOfferData?.id?.toString();
    onUpdateFeaturedAds(input, special_offer_id);
  };
  const currentStatus = specailOfferData?.status;
  const newStatus =
    currentStatus === SpecialOfferStatus.Active
      ? SpecialOfferStatus.InActive
      : SpecialOfferStatus.Active;
  useEffect(() => {
    if (!featuredAdsState.isLoading && submitted) {
      if (featuredAdsState.error) {
        setApiError(featuredAdsState.error);
      } else if (featuredAdsState.status === stateStatusType.SUCCESS) {
        onClose();
        resetSpecialOffer();
      } else {
        setApiError(null);
      }
    }
  }, [
    featuredAdsState.isLoading,
    featuredAdsState.error,
    featuredAdsState.status,
    submitted,
  ]);
  useEffect(() => {
    resetSpecialOffer();
  }, []);
  return (
    <>
      {" "}
      <div className="text-center font-bold my-2 text-lg">Confirmation</div>
      <div className="text-center font-bold text-md my-5">
        Are you sure, you want to {newStatus}?
      </div>
      <div className="flex justify-evenly">
        <CancelButton onClick={onClose}>No</CancelButton>
        <SubmitButton
          onClick={(e) => {
            handleSave(e);
          }}
        >
          Yes
        </SubmitButton>
      </div>
      <div>{apiError && <ApiError>{apiError}</ApiError>}</div>
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onUpdateFeaturedAds: (input: CreateSpecialOfferInput, special_offer_id: string) =>
    dispatch(updateSpecialOffer(input, special_offer_id)),
  onResetSpecialOffer: () => dispatch(resetSpecialOffer()),
});
export default connect(null, mapDispatchToProps)(HandleChangeStatus);
